// @flow
import React, { type Node } from 'react';

import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';
import Link from 'app/common/lib/link';

import {
  Price,
  Highlight,
  HighlightTable as HT,
  HighlightHeader,
} from 'app/common/layouts/commonShop';

import styles from './Summary.module.scss';;


type Props = {
  linkReturn?: string,
  itemsNumber: number,
  children?: Node,
  className?: string,
  sum?: number | string,
  amountDiscount?: number | string,
  total?: number | string,
  hideButtons?: boolean,
}

const Summary = ({
  linkReturn,
  itemsNumber,
  children,
  className,
  sum,
  amountDiscount,
  total,
  hideButtons,
}: Props) => (
  <Highlight className={className}>
    <HT.Table className={styles.table}>
      {linkReturn
        && <HT.Row>
          <HT.Cell><HighlightHeader>{'Заказ'}</HighlightHeader></HT.Cell>
          <HT.Cell><Link to={linkReturn} className={styles.link}>{'Изменить'}</Link></HT.Cell>
        </HT.Row>}
      <HT.Row>
        <HT.Cell className={styles.cellNoWrap}>{`Товары (${itemsNumber})`}</HT.Cell>
        <HT.Cell>{toFixedValueCurrency(sum)}</HT.Cell>
      </HT.Row>
      <HT.Row>
        <HT.Cell className={styles.cellNoWrap}>{'Скидка на товары'}</HT.Cell>
        <HT.Cell>{toFixedValueCurrency(amountDiscount)}</HT.Cell>
      </HT.Row>
      <HT.Row>
        <HT.Cell>{'Доставка'}</HT.Cell>
        <HT.Cell>{'Бесплатно'}</HT.Cell>
      </HT.Row>
      <HT.RowLine />
      <HT.Row>
        <HT.Cell><Price>{'Итого'}</Price></HT.Cell>
        <HT.Cell><Price>{toFixedValueCurrency(total)}</Price></HT.Cell>
      </HT.Row>
      {children
        && !hideButtons
        && React.Children.map(children, comp => (comp
          && <HT.Row>
            <HT.CellWide>
              {comp}
            </HT.CellWide>
          </HT.Row>
        ))}
    </HT.Table>
  </Highlight>
);


export default Summary;
